import { send } from 'server';

export const SET_LIST = 'LEADERBOARD_SET_LIST';
export const UPDATE_LIST = 'LEADERBOARD_UPDATE_LIST';
export const SET_DETAILS = 'LEADERBOARD_SET_DETAILS';
export const UPDATE_DETAILS = 'LEADERBOARD_UPDATE_DETAILS';

export const join = ({ leaderboardId }) => send({
    ID: 71004,
    responses: [71005, 71006],
    leaderboardId,
    description: 'Add player to Leaderboard'
});

export const leave = ({ leaderboardId }) => send({
    ID: 71007,
    responses: [71008, 71009],
    leaderboardId,
    description: 'Remove player from Leaderboard'
});

export const subscribeSummary = ({
                                     clientType,
                                     clientPlatform,
                                     game,
                                     notificationFieldsWhitelist,
                                     responseFieldsWhitelist
                                 }) => send({
    ID: 71010,
    responses: [71011, 71012],
    description: 'Subscribe Leaderboards Summary notifications',
    clientType,
    clientPlatform,
    game,
    notificationFieldsWhitelist,
    responseFieldsWhitelist
});

export const unsubscribeSummary = () => send({
    ID: 71013,
    responses: [71014, 71015],
    description: 'Unsubscribe Leaderboards Summary notifications'
});

export const fetchActiveList = ({
                                    filterByStatus,
                                    filterByRegistrationStatus,
                                    game,
                                    clientType,
                                    clientPlatform
                                }) => send({
    ID: 71022,
    responses: [71023, 71024],
    description: 'Get player\'s active leaderboards list',
    filterByStatus,
    filterByRegistrationStatus,
    gamingContext: {
        clientType,
        clientPlatform,
        game
    }
});

export const fetchHistoricalList = ({ filterByEndTime, startFrom, count }) => send({
    ID: 71025,
    responses: [71026, 71027],
    description: 'Get list of player\'s historical leaderboards',
    filterByEndTime,
    startFrom,
    count
});

export const fetchDetails = ({
                                 leaderboardId,
                                 topCompetitorsCount,
                                 fieldsWhitelist,
                                 networkId
                             }) => send({
    ID: 71001,
    responses: [71002, 71003],
    description: 'Get player\'s leaderboard details',
    leaderboardId,
    topCompetitorsCount,
    fieldsWhitelist,
    networkId
});

export const fetchDetailsByIds = ({ leaderboardIds, topCompetitorsCount, networkId }) => send({
    ID: 71101,
    responses: [71102, 71103],
    description: 'Get player\'s leaderboard details list by specified IDs',
    leaderboardIds,
    topCompetitorsCount,
    networkId
});

export const subscribeDetails = ({
                                     leaderboardId,
                                     topCompetitorsCount,
                                     networkId,
                                     notificationFieldsWhitelist
                                 }) => send({
    ID: 71016,
    responses: [71017, 71018],
    description: 'Subscribe for leaderboard details notifications',
    leaderboardId,
    topCompetitorsCount,
    networkId,
    notificationFieldsWhitelist
});

export const unsubscribeDetails = ({ leaderboardId }) => send({
    ID: 71019,
    responses: [71020, 71021],
    description: 'Cancel subscription for leaderboard details notifications',
    leaderboardId
});

export const setListAction = leaderboards => ({
    type: SET_LIST,
    payload: {
        leaderboards
    }
});

export const updateListAction = payload => ({
    type: UPDATE_LIST,
    payload
});

export const setDetailsAction = details => ({
    type: SET_DETAILS,
    payload: {
        details
    }
});

export const updateDetailsAction = details => ({
    type: UPDATE_DETAILS,
    payload: {
        details
    }
});
